import { render, staticRenderFns } from "./modalInactivarTienda.vue?vue&type=template&id=7247b3bb&scoped=true&"
import script from "./modalInactivarTienda.vue?vue&type=script&lang=js&"
export * from "./modalInactivarTienda.vue?vue&type=script&lang=js&"
import style0 from "./modalInactivarTienda.vue?vue&type=style&index=0&id=7247b3bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247b3bb",
  null
  
)

export default component.exports